export const INDEX_DETAILS = "INDEX_DETAILS";
export const INDEX_DETAILS_ERROR = "INDEX_DETAILS_ERROR";
export const INDEX_DETAILS_HIDE_ERROR = "INDEX_DETAILS_HIDE_ERROR";
export const INDEX_DETAILS_START_LOADER = "INDEX_DETAILS_START_LOADER";
export const INDEX_DETAILS_STOP_LOADER = "INDEX_DETAILS_STOP_LOADER";
export const STREAM_INDEX_DETAILS = "STREAM_INDEX_DETAILS";
